
import { gsap} from "gsap";
import { ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class Parallaxe {

  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    let getRatio = () => {
      if (window.innerWidth < 720) {
        return 1;
      }
      return 1.2;
    }; //;() => window.innerHeight / (window.innerHeight + this.container.offsetHeight); // change ratio?

    this.bg = this.container.querySelector(".bg");

    let i = 0;

    let mm = gsap.matchMedia();
    let effect;

    mm.add("(min-width: 769px)", () => {

      effect = gsap.fromTo(this.bg, {
        // backgroundPosition: () => i ? `50% ${-window.innerHeight * getRatio()}px` : "50% 0px"
        backgroundPosition: () => i ? `50% ${-window.innerHeight * getRatio()}px` : "50% 0px"
      }, {
        backgroundPosition: () => `50% ${window.innerHeight * (1 - getRatio())}px`,
        ease: "none",
        scrollTrigger: {
          trigger: this.container,
          start: this.container.dataset.start ?? "top center",
          end: this.container.dataset.end ?? "bottom center",
          scrub: true,
          invalidateOnRefresh: true
        }
      });

      return () => {

      };
    });


  }

  switch() {

  }
}
